import React from 'react';
import { Tooltip, useTheme } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { PaddedInfoIcon, PaddedWarningIcon } from '../InfoLink/style';

interface TooltipedIconProps {
    tooltip: NonNullable<React.ReactNode>;
    tooltipFontSize: CSSProperties['fontSize'];
    variant: 'info' | 'warning';
}

const variantToIconMap: Record<TooltipedIconProps['variant'], typeof PaddedInfoIcon> = {
    info: PaddedInfoIcon,
    warning: PaddedWarningIcon,
};

const TooltipedIcon = ({ variant, tooltip, tooltipFontSize }: TooltipedIconProps) => {
    const theme = useTheme();
    const color = theme.palette[variant].main;
    const Icon = variantToIconMap[variant];
    return (
        <Tooltip
            title={tooltip}
            enterTouchDelay={0}
            leaveTouchDelay={5000}
        >
            <Icon style={{ color, fontSize: tooltipFontSize }} />
        </Tooltip>
    );
};

export const TooltipedInfoIcon = ({ tooltip, tooltipFontSize }: Omit<TooltipedIconProps, 'variant' | 'color'>) => (
    <TooltipedIcon
        variant='info'
        tooltip={tooltip}
        tooltipFontSize={tooltipFontSize}
    />
);

export const TooltipedWarningIcon = ({ tooltip, tooltipFontSize }: Omit<TooltipedIconProps, 'variant' | 'color'>) => (
    <TooltipedIcon
        variant='warning'
        tooltip={tooltip}
        tooltipFontSize={tooltipFontSize}
    />
);

